const portfolios = [
  {
    id: 1,
    title: "VovóModerna",
    description: "Aplicativo para procurar uma receita específica",
    tech: "HTML5 - CSS3 - JS - REACT.JS - Context API - RTL",
    category: "FRONT",
    image: "https://github.com/Eliedson1979/vovomoderna/raw/main/src/images/Readme-preview.png",
    linkDemo: "https://eliedson1979.github.io/vovomoderna/",
    linkGithub: "https://github.com/Eliedson1979/vovomoderna",
  },
  {
    id: 2,
    title: "Cavaleiros-Zodiaco",
    description: "Jogo de Cartas, estilo Super Trunfo",
    tech: "HTML5 - CSS3 - JS - REACT.JS - REDUX - REACT ROUTER V5",
    category: "FRONT",
    image: "https://github.com/Eliedson1979/cavaleiros-zodiaco/raw/main/imgs/Readme-preview.png",
    linkDemo: "https://eliedson1979.github.io/cavaleiros-zodiaco/#/",
    linkGithub: "https://github.com/Eliedson1979/cavaleiros-zodiaco",
  },
  {
    id: 3,
    title: "MusicFly",
    description: "Aplicação para ouvir suas musicas.",
    tech: "HTML5 - CSS3 - JS - REACT.JS - REACT ROUTER V5",
    category: "FRONT",
    image: "https://github.com/Eliedson1979/musicfly/raw/main/src/images/preview.png",
    linkDemo: "https://eliedson1979.github.io/musicfly/#/",
    linkGithub: "https://github.com/Eliedson1979/musicfly"
  },
  {
    id: 4,
    title: "Trivia",
    description: "Aplicação para pergunta e resposta.",
    tech: "HTML5 - CSS3 - JS - REACT.JS - REDUX",
    category: "FRONT",
    image: "https://github.com/Eliedson1979/trivia/raw/main/imgs/preview.png",
    linkDemo: "https://eliedson1979.github.io/trivia/#/",
    linkGithub: "https://github.com/Eliedson1979/trivia",
  },
  {
    id: 5,
    title: "Wallet.",
    description: "Aplicação de carteira pra controlar os gastos...",
    tech: "HTML5 - CSS3 - JS - REACT.JS - REDUX - REACT ROUTER V5",
    category: "FRONT",
    image: "https://github.com/Eliedson1979/wallet/raw/main/imgs/preview.png",
    linkDemo: "https://eliedson1979.github.io/wallet/#/",
    linkGithub: "https://github.com/Eliedson1979/wallet",
  },

  {
    id: 6,
    title: "PixelArt",
    description: "Aplicação de um quadro de pixels que permite ao usuário pintar ponto a ponto em cores de sua escolha",
    tech: "HTML5 - CSS3 - JS",
    category: "BACK",
    image: "https://github.com/Eliedson1979/pixelart/raw/main/src/preview.png",
    linkDemo: "https://eliedson1979.github.io/pixelart/",
    linkGithub: "https://github.com/Eliedson1979/pixelart",
  },
  {
    id: 7,
    title: "ShoppingCart",
    description: "Nesse projeto desenvolvi uma aplicação de carrinho de compras, onde foi práticado o desenvolvimento orientado a testes, o famoso TDD (Test Driven Development).",
    tech: "HTML5 - CSS3 - JS - TDD",
    category: "FRONT",
    image: "https://github.com/Eliedson1979/shoppingcart/raw/main/preview.png",
    linkDemo: "https://eliedson1979.github.io/shoppingcart/",
    linkGithub: "https://github.com/Eliedson1979/shoppingcart",
  },
  {
    id: 8,
    title: "SolarSystem",
    description: "Nesse projeto desenvolvi uma aplicação para criar uma lista de planetas e algumas missões espaciais.",
    tech: "HTML5 - CSS3 - JS - REACT.JS",
    category: "FRONT",
    image: "https://github.com/Eliedson1979/solarsystem/raw/main/preview.png",
    linkDemo: "https://eliedson1979.github.io/solarsystem/",
    linkGithub: "https://github.com/Eliedson1979/solarsystem",
  },
  {
    id: 9,
    title: "TodoList",
    description: "Nesse projeto desenvolvido uma aplicação para Lista de Tarefas a fazer.",
    tech: "HTML5 - CSS3 - JS",
    category: "BACK",
    image: "https://github.com/Eliedson1979/todolist/raw/main/preview.png",
    linkDemo: "https://eliedson1979.github.io/todolist/",
    linkGithub: "https://github.com/Eliedson1979/todolist",
  },
];

export default portfolios;
